import { NgModule } from "@angular/core";

import { RoomsComponent } from "./rooms/rooms.component";
import { RolesComponent } from "./roles/roles.component";
import { GroupComponent } from "./groups/group.component";
import { BranchComponent } from "./branch/branch.component";
import { sharedModule } from "src/app/shared/shared.module";
import { HoldingComponent } from "./holding/holding.component";
import { CompanyComponent } from "./company/company.component";
import { RoomListComponent } from "./rooms/room-list/room-list.component";
import { RoomEntryComponent } from "./rooms/room-entry/room-entry.component";
import { DegreeMajorComponent } from "./degree-major/degree-major.component";
import { RoleEntryComponent } from "./roles/role-entry/role-entry.component";
import { GroupListComponent } from "./groups/group-list/group-list.component";
import { RoleDetailComponent } from "./roles/role-detail/role-detail.component";
import { GroupEntryComponent } from "./groups/group-entry/group-entry.component";
import { GroupDetailComponent } from "./groups/group-detail/group-detail.component";
import { BranchEntryComponent } from "./branch/branch-entry/branch-entry.component";
import { CompanyEntryComponent } from "./company/company-entry/company-entry.component";
import { HoldingEntryComponent } from "./holding/holding-entry/holding-entry.component";
import { AddManagerEntryComponent } from "./company/add-manager-entry/add-manager-entry.component";
import { GroupRouteActionComponent } from "./groups/group-route-action/group-route-action.component";
import { RoleTreeStructureComponent } from "./roles/role-tree-structure/role-tree-structure.component";
import { DegreeMajorEntryComponent } from "./degree-major/degree-major-entry/degree-major-entry.component";
import { CalenderManagementComponent } from './company/calender-management/calender-management.component';
import { LogCalendarEventComponent } from './company/log-calendar-event/log-calendar-event.component';

@NgModule({
  declarations: [
    HoldingComponent,
    HoldingEntryComponent,
    BranchComponent,
    BranchEntryComponent,
    CompanyComponent,
    AddManagerEntryComponent,
    CompanyEntryComponent,
    DegreeMajorComponent,
    DegreeMajorEntryComponent,
    GroupComponent,
    GroupDetailComponent,
    GroupEntryComponent,
    GroupListComponent,
    GroupRouteActionComponent,
    RolesComponent,
    RoleDetailComponent,
    RoleEntryComponent,
    RoleTreeStructureComponent,
    RoomsComponent,
    RoomListComponent,
    RoomEntryComponent,
    CalenderManagementComponent,
    LogCalendarEventComponent
  ],
  imports: [sharedModule],
  entryComponents: [
    RoomEntryComponent,
    RoleEntryComponent,
    GroupEntryComponent,
    BranchEntryComponent,
    HoldingEntryComponent,
    CompanyEntryComponent,
    AddManagerEntryComponent,
    LogCalendarEventComponent,
    DegreeMajorEntryComponent
  ]
})
export class BasicInfoModule {}
